import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import { RedPointsBenefitDialog } from '../../../../redpoints'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'
import { type ProductSearchResultItemLabel } from './useProductSearchResultItemLabels'

export const ProductSearchResultItemRedPointsLabel: FC<{
  label: ProductSearchResultItemLabel
}> = ({ label }) => {
  const multiplier = label.redPointsMultiplierSpecific?.multiplier
  const modalControls = useOpenableControls()

  if (!multiplier) {
    return null
  }

  return (
    <>
      <ProductSearchResultItemGenericLabel
        className="border-light-primary-strong bg-light-primary-medium text-dark-primary-max"
        data-qa-id="form-red-points-modal-button"
        onClick={modalControls.handleOpen}
      >
        <>
          {multiplier}
          {'x '}
          <FormattedMessage id="general.label.redPoints" />
          <IconInfo className="ml-2 size-4" />
        </>
      </ProductSearchResultItemGenericLabel>
      <RedPointsBenefitDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
